import React from "react";

export const DeDust: React.FC<React.SVGProps<SVGSVGElement>> = () => (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 11.0009L12.4734 9.63672V12.365L10 13.7292V11.0009Z" fill="#CC7400" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.106 11.0574V13.5527L12.3659 12.3063V9.81098L10.106 11.0574ZM9.94539 10.913L12.4187 9.54883L12.5794 9.6356V12.3639L12.5266 12.4507L10.0532 13.8148L9.89258 13.7281V10.9998L9.94539 10.913Z"
            fill="#CC7400"
        />
        <path d="M10 19.1845L12.4734 17.8203V20.5486L10 21.9128V19.1845Z" fill="#DE7F00" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.106 19.243V21.7382L12.3659 20.4918V17.9965L10.106 19.243ZM9.94539 19.0985L12.4187 17.7344L12.5794 17.8211V20.5495L12.5266 20.6362L10.0532 22.0004L9.89258 21.9136V19.1853L9.94539 19.0985Z"
            fill="#DE7F00"
        />
        <path d="M10 16.4579L12.4734 15.0938V17.8221L10 19.1862V16.4579Z" fill="#D17200" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.106 16.5144V19.0097L12.3659 17.7633V15.268L10.106 16.5144ZM9.94539 16.37L12.4187 15.0059L12.5794 15.0926V17.8209L12.5266 17.9077L10.0532 19.2719L9.89258 19.1851V16.4568L9.94539 16.37Z"
            fill="#D17200"
        />
        <path d="M10 13.7274L12.4734 12.3633V15.0916L10 16.4557V13.7274Z" fill="#E38900" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.107 13.7859V16.2812L12.3669 15.0348V12.5395L10.107 13.7859ZM9.94636 13.6415L12.4197 12.2773L12.5804 12.3641V15.0924L12.5276 15.1792L10.0542 16.5434L9.89355 16.4566V13.7283L9.94636 13.6415Z"
            fill="#E38900"
        />
        <path d="M17.4199 6.90712L19.8933 5.54297V8.27128L17.4199 9.63543V6.90712Z" fill="#C97900" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5269 6.96561V9.46089L19.7868 8.21446V5.71918L17.5269 6.96561ZM17.3663 6.82118L19.8396 5.45703L20.0003 5.54381V8.27211L19.9475 8.35889L17.4741 9.72304L17.3135 9.63627V6.90796L17.3663 6.82118Z"
            fill="#C97900"
        />
        <path d="M17.4199 15.0927L19.8933 13.7285V16.4568L17.4199 17.821V15.0927Z" fill="#C96E00" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5269 15.1492V17.6445L19.7868 16.3981V13.9028L17.5269 15.1492ZM17.3663 15.0048L19.8396 13.6406L20.0003 13.7274V16.4557L19.9475 16.5425L17.4741 17.9066L17.3135 17.8199V15.0916L17.3663 15.0048Z"
            fill="#C96E00"
        />
        <path d="M17.4199 12.3642L19.8933 11V13.7283L17.4199 15.0925V12.3642Z" fill="#CC7400" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5269 12.4226V14.9179L19.7868 13.6715V11.1762L17.5269 12.4226ZM17.3663 12.2782L19.8396 10.9141L20.0003 11.0008V13.7291L19.9475 13.8159L17.4741 15.1801L17.3135 15.0933V12.365L17.3663 12.2782Z"
            fill="#CC7400"
        />
        <path
            d="M17.4196 9.63456L19.893 8.2704V10.9987L17.4196 12.3629V9.63456ZM14.9463 8.2704L17.4196 6.90625V9.63456L14.9463 10.9987V8.2704Z"
            fill="#E68A00"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.0533 8.32889V10.8242L17.3132 9.57774V7.08247L15.0533 8.32889ZM17.5267 9.46002V6.90709L17.366 6.82031L14.8927 8.18447L14.8398 8.27124V10.9995L15.0005 11.0863L17.3132 9.81077V12.3637L17.4738 12.4505L19.9472 11.0863L20 10.9995V8.27124L19.8394 8.18447L17.5267 9.46002ZM17.5267 9.69304V12.1883L19.7865 10.9419V8.44662L17.5267 9.69304Z"
            fill="#E68A00"
        />
        <path d="M14.9463 16.4579L17.4196 15.0938V17.8221L14.9463 19.1862V16.4579Z" fill="#D68100" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.0533 16.5144V19.0097L17.3132 17.7633V15.268L15.0533 16.5144ZM14.8927 16.37L17.366 15.0059L17.5267 15.0926V17.8209L17.4738 17.9077L15.0005 19.2719L14.8398 19.1851V16.4568L14.8927 16.37Z"
            fill="#D68100"
        />
        <path d="M14.9463 13.7274L17.4196 12.3633V15.0916L14.9463 16.4557V13.7274Z" fill="#C96E00" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.0533 13.7859V16.2812L17.3132 15.0348V12.5395L15.0533 13.7859ZM14.8927 13.6415L17.366 12.2773L17.5267 12.3641V15.0924L17.4738 15.1792L15.0005 16.5434L14.8398 16.4566V13.7283L14.8927 13.6415Z"
            fill="#C96E00"
        />
        <path d="M14.9463 11.0009L17.4196 9.63672V12.365L14.9463 13.7292V11.0009Z" fill="#DB7D00" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.0533 11.0574V13.5527L17.3132 12.3063V9.81098L15.0533 11.0574ZM14.8927 10.913L17.366 9.54883L17.5267 9.6356V12.3639L17.4738 12.4507L15.0005 13.8148L14.8398 13.7281V10.9998L14.8927 10.913Z"
            fill="#DB7D00"
        />
        <path d="M12.4736 9.63564L14.947 8.27148V10.9998L12.4736 12.3639V9.63564Z" fill="#D18100" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5797 9.69217V12.1875L14.8396 10.941V8.44575L12.5797 9.69217ZM12.419 9.54775L14.8924 8.18359L15.053 8.27037V10.9987L15.0002 11.0854L12.5269 12.4496L12.3662 12.3628V9.63452L12.419 9.54775Z"
            fill="#D18100"
        />
        <path d="M12.4736 17.8212L14.947 16.457V19.1853L12.4736 20.5495V17.8212Z" fill="#C47000" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5797 17.8797V20.375L14.8396 19.1285V16.6332L12.5797 17.8797ZM12.419 17.7352L14.8924 16.3711L15.053 16.4579V19.1862L15.0002 19.2729L12.5269 20.6371L12.3662 20.5503V17.822L12.419 17.7352Z"
            fill="#C47000"
        />
        <path d="M12.4736 15.0927L14.947 13.7285V16.4568L12.4736 17.821V15.0927Z" fill="#D17E00" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5797 15.1492V17.6445L14.8396 16.3981V13.9028L12.5797 15.1492ZM12.419 15.0048L14.8924 13.6406L15.053 13.7274V16.4557L15.0002 16.5425L12.5269 17.9066L12.3662 17.8199V15.0916L12.419 15.0048Z"
            fill="#D17E00"
        />
        <path d="M12.4736 12.3642L14.947 11V13.7283L12.4736 15.0925V12.3642Z" fill="#CC7400" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5797 12.4226V14.9179L14.8396 13.6715V11.1762L12.5797 12.4226ZM12.419 12.2782L14.8924 10.9141L15.053 11.0008V13.7291L15.0002 13.8159L12.5269 15.1801L12.3662 15.0933V12.365L12.419 12.2782Z"
            fill="#CC7400"
        />
        <path
            d="M0.106445 5.54297L2.5798 6.90712V9.63543L0.106445 8.27127V5.54297ZM0.106445 13.7279L2.5798 15.092V17.8203L0.106445 16.4562V13.7279Z"
            fill="#FC9800"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 5.54381L0.160648 5.45703L2.634 6.82118L2.68681 6.90796V9.63627L2.52616 9.72304L0.0528072 8.35889L0 8.27211V5.54381ZM0.213455 5.71918V8.21446L2.47335 9.46089V6.96561L0.213455 5.71918ZM0 13.7287L0.160648 13.642L2.634 15.0061L2.68681 15.0929V17.8212L2.52616 17.908L0.0528072 16.5438L0 16.457V13.7287ZM0.213455 13.9041V16.3994L2.47335 17.6458V15.1505L0.213455 13.9041Z"
            fill="#FC9800"
        />
        <path d="M0.106445 11L2.5798 12.3642V15.0925L0.106445 13.7283V11Z" fill="#FFAA00" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 11.0008L0.160648 10.9141L2.634 12.2782L2.68681 12.365V15.0933L2.52616 15.1801L0.0528072 13.8159L0 13.7291V11.0008ZM0.213455 11.1762V13.6715L2.47335 14.9179V12.4226L0.213455 11.1762Z"
            fill="#FFAA00"
        />
        <path d="M0.106445 8.27148L2.5798 9.63564V12.3639L0.106445 10.9998V8.27148Z" fill="#FFBD1E" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 8.27037L0.160648 8.18359L2.634 9.54775L2.68681 9.63452V12.3628L2.52616 12.4496L0.0528072 11.0854L0 10.9987V8.27037ZM0.213455 8.44575V10.941L2.47335 12.1875V9.69217L0.213455 8.44575Z"
            fill="#FFBD1E"
        />
        <path d="M7.52637 9.63672L9.99972 11.0009V13.7292L7.52637 12.365V9.63672Z" fill="#FC9800" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.41992 9.6356L7.58057 9.54883L10.0539 10.913L10.1067 10.9998V13.7281L9.94608 13.8148L7.47273 12.4507L7.41992 12.3639V9.6356ZM7.63338 9.81098V12.3063L9.89327 13.5527V11.0574L7.63338 9.81098Z"
            fill="#FC9800"
        />
        <path d="M7.52734 17.8203L10.0007 19.1845V21.9128L7.52734 20.5486V17.8203Z" fill="#FFAA00" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.41992 17.8211L7.58057 17.7344L10.0539 19.0985L10.1067 19.1853V21.9136L9.94608 22.0004L7.47273 20.6362L7.41992 20.5495V17.8211ZM7.63338 17.9965V20.4918L9.89327 21.7382V19.243L7.63338 17.9965Z"
            fill="#FFAA00"
        />
        <path d="M7.52734 15.0938L10.0007 16.4579V19.1862L7.52734 17.8221V15.0938Z" fill="#FFAA00" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.41992 15.0926L7.58057 15.0059L10.0539 16.37L10.1067 16.4568V19.1851L9.94608 19.2719L7.47273 17.9077L7.41992 17.8209V15.0926ZM7.63338 15.268V17.7633L9.89327 19.0097V16.5144L7.63338 15.268Z"
            fill="#FFAA00"
        />
        <path
            d="M7.52706 12.3639L10.0004 13.7281V16.4564L7.52706 15.0923V12.3639ZM5.05371 8.27148L7.52706 9.63564V12.3639L5.05371 10.9998V8.27148Z"
            fill="#FFAA00"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.94727 8.27037L5.10791 8.18359L7.58127 9.54775L7.63407 9.63452V12.3052L10.0546 13.6402L10.1074 13.727V16.4553L9.94678 16.5421L7.47342 15.1779L7.42062 15.0911V12.4205L5.00007 11.0854L4.94727 10.9987V8.27037ZM7.42062 12.1875V9.69217L5.16072 8.44575V10.941L7.42062 12.1875ZM7.63407 12.5382V15.0335L9.89397 16.2799V13.7846L7.63407 12.5382Z"
            fill="#FFAA00"
        />
        <path d="M5.05371 16.457L7.52706 17.8212V20.5495L5.05371 19.1853V16.457Z" fill="#FC9800" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.94727 16.4579L5.10791 16.3711L7.58127 17.7352L7.63407 17.822V20.5503L7.47342 20.6371L5.00007 19.2729L4.94727 19.1862V16.4579ZM5.16072 16.6332V19.1285L7.42062 20.375V17.8797L5.16072 16.6332Z"
            fill="#FC9800"
        />
        <path d="M5.05371 13.7285L7.52706 15.0927V17.821L5.05371 16.4568V13.7285Z" fill="#FFBD1E" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.94629 13.7274L5.10694 13.6406L7.58029 15.0048L7.6331 15.0916V17.8199L7.47245 17.9066L4.9991 16.5425L4.94629 16.4557V13.7274ZM5.15974 13.9028V16.3981L7.41964 17.6445V15.1492L5.15974 13.9028Z"
            fill="#FFBD1E"
        />
        <path d="M5.05371 11L7.52706 12.3642V15.0925L5.05371 13.7283V11Z" fill="#FFB304" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.94629 11.0008L5.10694 10.9141L7.58029 12.2782L7.6331 12.365V15.0933L7.47245 15.1801L4.9991 13.8159L4.94629 13.7291V11.0008ZM5.15974 11.1762V13.6715L7.41964 14.9179V12.4226L5.15974 11.1762Z"
            fill="#FFB304"
        />
        <path d="M2.58008 6.90625L5.05343 8.2704V10.9987L2.58008 9.63456V6.90625Z" fill="#FFAA00" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.47363 6.90709L2.63428 6.82031L5.10763 8.18447L5.16044 8.27124V10.9995L4.99979 11.0863L2.52644 9.72217L2.47363 9.63539V6.90709ZM2.68709 7.08247V9.57774L4.94699 10.8242V8.32889L2.68709 7.08247Z"
            fill="#FFAA00"
        />
        <path d="M2.58008 15.0938L5.05343 16.4579V19.1862L2.58008 17.8221V15.0938Z" fill="#FFB304" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.47363 15.0926L2.63428 15.0059L5.10763 16.37L5.16044 16.4568V19.1851L4.99979 19.2719L2.52644 17.9077L2.47363 17.8209V15.0926ZM2.68709 15.268V17.7633L4.94699 19.0097V16.5144L2.68709 15.268Z"
            fill="#FFB304"
        />
        <path d="M2.58008 12.3633L5.05343 13.7274V16.4557L2.58008 15.0916V12.3633Z" fill="#FFAA00" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.47363 12.3641L2.63428 12.2773L5.10763 13.6415L5.16044 13.7283V16.4566L4.99979 16.5434L2.52644 15.1792L2.47363 15.0924V12.3641ZM2.68709 12.5395V15.0348L4.94699 16.2812V13.7859L2.68709 12.5395Z"
            fill="#FFAA00"
        />
        <path d="M2.58008 9.63672L5.05343 11.0009V13.7292L2.58008 12.365V9.63672Z" fill="#FC9800" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.47363 9.6356L2.63428 9.54883L5.10763 10.913L5.16044 10.9998V13.7281L4.99979 13.8148L2.52644 12.4507L2.47363 12.3639V9.6356ZM2.68709 9.81098V12.3063L4.94699 13.5527V11.0574L2.68709 9.81098Z"
            fill="#FC9800"
        />
        <path
            d="M9.99985 0.0859375L12.4732 1.45009L9.99985 2.81424L7.5265 1.45009L9.99985 0.0859375ZM2.5798 4.1784L5.05315 5.54255L2.5798 6.9067L0.106445 5.54255L2.5798 4.1784Z"
            fill="#FFE929"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.73796 1.45093L10.0001 2.69857L12.2622 1.45093L10.0001 0.203289L7.73796 1.45093ZM7.47279 1.36415L9.94614 0H10.054L12.5273 1.36415V1.5377L10.054 2.90186H9.94614L7.47279 1.5377V1.36415ZM0.317906 5.54339L2.58001 6.79103L4.84211 5.54339L2.58001 4.29575L0.317906 5.54339ZM0.0527344 5.45661L2.52609 4.09246H2.63393L5.10728 5.45661V5.63016L2.63393 6.99431H2.52609L0.0527344 5.63016V5.45661Z"
            fill="#FFE929"
        />
        <path d="M5.05343 2.81641L7.52678 4.18056L5.05343 5.54471L2.58008 4.18056L5.05343 2.81641Z" fill="#FFE65E" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.79056 4.17944L5.05266 5.42708L7.31476 4.17944L5.05266 2.9318L2.79056 4.17944ZM2.52539 4.09267L4.99874 2.72852H5.10658L7.57993 4.09267V4.26622L5.10658 5.63037H4.99874L2.52539 4.26622V4.09267Z"
            fill="#FFE65E"
        />
        <path
            d="M7.52609 1.45117L9.99944 2.81533L7.52609 4.17948L5.05273 2.81533L7.52609 1.45117ZM17.4195 4.17948L19.8928 5.54363L17.4195 6.90778L14.9461 5.54363L17.4195 4.17948Z"
            fill="#FFDB2E"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.2642 2.81421L7.5263 4.06185L9.7884 2.81421L7.5263 1.56657L5.2642 2.81421ZM4.99902 2.72743L7.47238 1.36328H7.58022L10.0536 2.72743V2.90098L7.58022 4.26514H7.47238L4.99902 2.90098V2.72743ZM15.1576 5.54252L17.4197 6.79016L19.6818 5.54252L17.4197 4.29488L15.1576 5.54252ZM14.8924 5.45574L17.3658 4.09159H17.4736L19.947 5.45574V5.62929L17.4736 6.99344H17.3658L14.8924 5.62929V5.45574Z"
            fill="#FFDB2E"
        />
        <path d="M9.99972 8.27148L12.4731 9.63564L9.99972 10.9998L7.52637 9.63564L9.99972 8.27148Z" fill="#FFE65E" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.73783 9.63452L9.99993 10.8822L12.262 9.63452L9.99993 8.38688L7.73783 9.63452ZM7.47266 9.54775L9.94601 8.18359H10.0538L12.5272 9.54775V9.7213L10.0538 11.0855H9.94601L7.47266 9.7213V9.54775Z"
            fill="#FFE65E"
        />
        <path d="M12.4734 6.90625L14.9467 8.2704L12.4734 9.63456L10 8.2704L12.4734 6.90625Z" fill="#FFDB2E" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.2115 8.27124L12.4736 9.51888L14.7357 8.27124L12.4736 7.0236L10.2115 8.27124ZM9.94629 8.18447L12.4196 6.82031H12.5275L15.0008 8.18447V8.35802L12.5275 9.72217H12.4196L9.94629 8.35802V8.18447Z"
            fill="#FFDB2E"
        />
        <path d="M14.947 5.54297L17.4203 6.90712L14.947 8.27128L12.4736 6.90712L14.947 5.54297Z" fill="#FFE65E" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6841 6.90796L14.9462 8.1556L17.2083 6.90796L14.9462 5.66032L12.6841 6.90796ZM12.4189 6.82118L14.8923 5.45703H15.0001L17.4735 6.82118V6.99473L15.0001 8.35889H14.8923L12.4189 6.99473V6.82118Z"
            fill="#FFE65E"
        />
        <path d="M14.947 2.81641L17.4203 4.18056L14.947 5.54471L12.4736 4.18056L14.947 2.81641Z" fill="#FFE36A" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6841 4.17944L14.9462 5.42708L17.2083 4.17944L14.9462 2.9318L12.6841 4.17944ZM12.4189 4.09267L14.8923 2.72852H15.0001L17.4735 4.09267V4.26622L15.0001 5.63037H14.8923L12.4189 4.26622V4.09267Z"
            fill="#FFE36A"
        />
        <path d="M7.52609 6.90625L9.99944 8.2704L7.52609 9.63456L5.05273 8.2704L7.52609 6.90625Z" fill="#FFDB2E" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.2642 8.27124L7.5263 9.51888L9.78839 8.27124L7.5263 7.0236L5.2642 8.27124ZM4.99902 8.18447L7.47238 6.82031H7.58022L10.0536 8.18447V8.35802L7.58022 9.72217H7.47238L4.99902 8.35802V8.18447Z"
            fill="#FFDB2E"
        />
        <path d="M9.99972 5.54297L12.4731 6.90712L9.99972 8.27128L7.52637 6.90712L9.99972 5.54297Z" fill="#FFE36A" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.73783 6.90796L9.99993 8.1556L12.262 6.90796L9.99993 5.66032L7.73783 6.90796ZM7.47266 6.82118L9.94601 5.45703H10.0538L12.5272 6.82118V6.99473L10.0538 8.35889H9.94601L7.47266 6.99473V6.82118Z"
            fill="#FFE36A"
        />
        <path d="M12.4734 4.17969L14.9467 5.54384L12.4734 6.90799L10 5.54384L12.4734 4.17969Z" fill="#FFDB2E" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.2115 5.54468L12.4736 6.79232L14.7357 5.54468L12.4736 4.29704L10.2115 5.54468ZM9.94629 5.4579L12.4196 4.09375H12.5275L15.0008 5.4579V5.63145L12.5275 6.99561H12.4196L9.94629 5.63145V5.4579Z"
            fill="#FFDB2E"
        />
        <path d="M12.4734 1.45117L14.9467 2.81533L12.4734 4.17948L10 2.81533L12.4734 1.45117Z" fill="#FFE65E" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.2115 2.81421L12.4736 4.06185L14.7357 2.81421L12.4736 1.56657L10.2115 2.81421ZM9.94629 2.72743L12.4196 1.36328H12.5275L15.0008 2.72743V2.90098L12.5275 4.26514H12.4196L9.94629 2.90098V2.72743Z"
            fill="#FFE65E"
        />
        <path d="M5.05343 5.54297L7.52678 6.90712L5.05343 8.27128L2.58008 6.90712L5.05343 5.54297Z" fill="#FFE929" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.79056 6.90796L5.05266 8.1556L7.31476 6.90796L5.05266 5.66032L2.79056 6.90796ZM2.52539 6.82118L4.99874 5.45703H5.10658L7.57993 6.82118V6.99473L5.10658 8.35889H4.99874L2.52539 6.99473V6.82118Z"
            fill="#FFE929"
        />
        <path d="M7.52609 4.17969L9.99944 5.54384L7.52609 6.90799L5.05273 5.54384L7.52609 4.17969Z" fill="#FFE65E" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.2642 5.54468L7.5263 6.79232L9.78839 5.54468L7.5263 4.29704L5.2642 5.54468ZM4.99902 5.4579L7.47238 4.09375H7.58022L10.0536 5.4579V5.63145L7.58022 6.99561H7.47238L4.99902 5.63145V5.4579Z"
            fill="#FFE65E"
        />
        <path d="M9.99972 2.81641L12.4731 4.18056L9.99972 5.54471L7.52637 4.18056L9.99972 2.81641Z" fill="#FFE929" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.73783 4.17944L9.99993 5.42708L12.262 4.17944L9.99993 2.9318L7.73783 4.17944ZM7.47266 4.09267L9.94601 2.72852H10.0538L12.5272 4.09267V4.26622L10.0538 5.63037H9.94601L7.47266 4.26622V4.09267Z"
            fill="#FFE929"
        />
    </svg>
);
export const StonFi: React.FC<React.SVGProps<SVGSVGElement>> = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.377 14.49C12.4992 14.4084 12.6684 14.4608 12.7186 14.5957L14.6187 19.7074C14.6798 19.8718 14.5259 20.0353 14.3503 19.9924L7.35429 18.283C7.16612 18.237 7.12153 17.9988 7.28113 17.8923L12.377 14.49Z"
            fill="#027BFF"
        />
        <path
            d="M13.6051 13.3627C13.5963 13.3391 13.5919 13.3142 13.5919 13.2891V8.13739C13.5919 7.9917 13.4465 7.88695 13.3016 7.92825L7.3068 9.63684C7.16192 9.67814 7.0166 9.57339 7.0166 9.42769V6.09825C7.0166 6.0302 7.04953 5.96605 7.10568 5.9248L14.9177 0.183331C15.0263 0.103535 15.1829 0.134004 15.2509 0.248162L19.9701 8.17109C20.0035 8.22725 20.0093 8.2948 19.986 8.3555L16.0128 18.7025C15.9395 18.8934 15.6591 18.8919 15.5879 18.7003L13.6051 13.3627Z"
            fill="#027BFF"
        />
        <path
            d="M5.01625 0.629504C5.05394 0.593874 5.10344 0.572099 5.15606 0.567959L12.3663 0.000811827C12.5915 -0.0169039 12.7015 0.259816 12.5216 0.391767L6.37597 4.90069C6.31908 4.94243 6.24508 4.95577 6.17639 4.93668L2.12944 3.8116C1.96298 3.76532 1.91009 3.56311 2.03386 3.44621L5.01625 0.629504Z"
            fill="#027BFF"
        />
        <path
            d="M1.00279 4.9431C1.02003 4.81007 1.15645 4.72339 1.28999 4.76063L5.57899 5.95663C5.67576 5.98358 5.74232 6.06898 5.74232 6.16613V11.0084C5.74232 11.1542 5.88779 11.2589 6.03271 11.2175L11.9859 9.51652C12.1308 9.47512 12.2763 9.57987 12.2763 9.72562V12.8014C12.2763 12.8728 12.24 12.9397 12.1792 12.9805L5.50192 17.4566C5.41482 17.515 5.29738 17.5072 5.21946 17.4378L0.0727414 12.8551C0.0191356 12.8074 -0.00730012 12.7377 0.00174805 12.6679L1.00279 4.9431Z"
            fill="#027BFF"
        />
    </svg>
);
